import { Component, OnInit } from '@angular/core';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ColDef, ExcelExportParams, GridReadyEvent } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/service/shared/shared.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { DwmGenericServiceService } from '../../_DWM-Generic-Services/generic-service.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { ToastrService } from 'ngx-toastr';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';


@Component({
  selector: 'app-dwm-dump-report',
  templateUrl: './dwm-dump-report.component.html',
  styleUrls: ['./dwm-dump-report.component.scss'],
})
export class DwmDumpReportComponent implements OnInit {
  selectedYearForDWM: any = null;
  selectedMonthForDWM: string = '';
  filteredMonthsList: string[] = [];
  monthsList: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  loggedInUserRole: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserCompanyID: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserName: any;
  loggedInUserRoles: any;
  pmsYears: any = [];
  fromYear: any;
  selectedYear: any;
  toYear: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  isCurrentYearSelected: boolean = false;
  selectedFilters: any = {
    selectedDepartment: null,
    selectedEmpId: null,
    selectedYear: null,
    selectedMonth: null
  };
  currentPage: number = 1;
pageSize: number = 10;
totalPages: number = 0;

paginatedData: any[] = [];

startEntry: number = 0;
endEntry: number = 0;
totalEntries: number = 0;
  teamTableHeaders = [
    { label: 'Employee ID', key: 'employeeId' },
    { label: 'Employee Name', key: 'employeeName' },
    { label: 'Plant Location', key: 'plantLocation' },
    { label: 'Department', key: 'department' },
    { label: 'Grade', key: 'grade' },
    { label: 'Reporting Manager', key: 'reportingManager' },

    { label: 'No. of Tasks Submitted for Approval', key: 'tasksSubmitted' },
    { label: 'No. of Tasks Approved by Manager', key: 'tasksApproved' },
    { label: 'No. of Tasks Rejected by Manager', key: 'tasksRejected' },
    { label: 'No. of Tasks Pending from Manager Approval', key: 'tasksPendingApproval' },
    { label: 'No. of Draft Tasks', key: 'draftTasks' },

    { label: 'No. of Tasks Done on Time', key: 'tasksOnTime' },
    { label: 'No. of Tasks Done with Delay', key: 'tasksWithDelay' },
    { label: 'No. of Tasks Incomplete After Due Date', key: 'tasksIncompleteAfterDueDate' },
    { label: 'No. of Tasks Not Completed', key: 'tasksNotCompleted' },

    { label: 'Compliance Score', key: 'complianceScore' }
  ];

  constructor(
    public sharedService: SharedService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    public dwmGenericServiceService: DwmGenericServiceService,
    private datePipe: DatePipe,
    private getCompanyAndUserData: GetCompanyAndUsersData,
    public mobileResponsiveService: MobileResponsiveService
  ) { }

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');

    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    // if (this.dwmGenericServiceService?.showMtdView?.value?.userId) {
    //   this.isTeamView = true;
    //   this.onEmployeeChange(this.dwmGenericServiceService?.showMtdView?.value?.userId);
    // }

    // this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
    // if (this.dwmGenericServiceService?.getAllAccessAdmins) {
    //   this.dwmGenericServiceService.getAllAccessAdmins.subscribe({
    //     next: (data: any) => {
    //       if (data?.status) {
    //         this.adminAccessData = data?.data?.access[0];
    //         this.executeDataFunction();
    //       }
    //     }
    //   });
    // } else {
    //   this.executeDataFunction();
    // }

    // const currentMonthIndex = new Date().getMonth();
    // this.selectedMonthForDWM = this.monthsList[currentMonthIndex];
    // this.checkIfPreviousMonthSelected();
    this.getpmsyearlist();
  }

  executeDataFunction() {
    this.getpmsyearlist();
    if (this.dwmGenericServiceService?.showMtdView?.value?.userId) {
      // this.isTeamView = true;
      this.onEmployeeChange(this.dwmGenericServiceService?.showMtdView?.value?.userId);
    }
  }

  // --------------- Get PMS Year List -----------------

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  // --------------- Set Selected Year -----------------

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getYearSetupForDWM(this.selectedYearForDWM);
      this.getPlantsLocation();
      // this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj?.year?.split('-');
    }
  }

  // --------------- Get Year Setup For DWM -----------------

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;

    this.isCurrentYearSelected = year === currentFiscalYear;
     this.selectedMonthForDWM = '';
  this.filteredMonthsList = [];

  this.resetAllFiltersAfterMonth();

    this.filterMonthsByFiscalYear(year);
  }


  resetAllFiltersAfterMonth() {
  this.selectedPlants = [];
  this.departmentsList = [];
  this.selectedDepartments = [];
  this.employeesList = [];
  this.selectedEmployees = [];
  this.reportData = [];
  this.paginatedData = [];
}
  filterMonthsByFiscalYear(selectedYear: string) {
    const fiscal = this.loggedInCompanyFiscalyear;
    const [startMon, endMon] = fiscal?.split('_');

    const monthIndex = (mon: string) => new Date(`${mon} 1, 2000`).getMonth();

    const startIdx = monthIndex(startMon);
    const endIdx = monthIndex(endMon);

    this.filteredMonthsList = startIdx <= endIdx ? this.monthsList.slice(startIdx, endIdx + 1) : [...this.monthsList.slice(startIdx), ...this.monthsList.slice(0, endIdx + 1)];

    const currentMonth = new Date().toLocaleString('default', {
      month: 'long'
    });

    this.selectedMonthForDWM = this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth) ? currentMonth : '';
    if (!this.selectedMonthForDWM) this.resetFilters('c3');
  }


  onEmployeeChange(selectedEmpId: number): void {
    this.selectedFilters.selectedEmpId = selectedEmpId;
    this.dwmGenericServiceService.showMtdView.next(null);
    //  Get department from map (NOT dropdown object)
    // const department = this.employeeDepartmentMap[selectedEmpId];
    // this.isSelectedEmployeeRNDEmployee = department === 'R&D';

  }


  onAdminEmployeeChange(selectedEmpId: number): void {
    this.dwmGenericServiceService.showMtdView.next(null);
    this.selectedFilters.selectedEmpId = selectedEmpId;
    //  Get department from map

  }



  changeReportsData() {
    if (!this.selectedMonthForDWM) return;
      this.resetAllFiltersAfterMonth();
    // this.prepareDays();
    // this.getWeeklyOff();
    // this.getReportDataForNonRNDEmp();
  
    // this.complianceScore();
  }

  resetFilters(filter: string) {
    // if (filter === 'c1') {
    //   this.selectedGrades = [];
    //   this.selectedFilters.selectedEmpId = null;
    //   this.gradesList = [];
    //   this.employeesList = [];
    // } else if (filter === 'c2') {
    //   this.selectedFilters.selectedEmpId = null;
    //   this.employeesList = [];
    // }
  }


  //  ------------------------------ Get Plants Location -------------------------------------
   plantDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
      idField: 'id',
  textField: 'name'
  };

  plantList: any[] = [];
  selectedPlants: string[] = [];

    getPlantsLocation() {
    this.httpService.callGetService(`${this.config.getPlantList}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      this.plantList =(data?.data || []).map((item:any)=>
      item.plantLocation);
    });
  }


  onPlantSelect() {
  this.getDepartmentByPlantsLocation();
  }


  onPlantDeselect() {
  this.getDepartmentByPlantsLocation();
  }

  onPlantSelectAll(items:any[]) {
    this.selectedPlants = items;
    this.getDepartmentByPlantsLocation();
  }

  onPlantDeSelectAll() {
    this.selectedPlants = [];
  this.getDepartmentByPlantsLocation();
  }

  //  ------------------------------------------- Get Departments by Plant Location -------------------------------------
departmentDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
     idField: 'id',      
  textField: 'name'
  };

  departmentsList: any[] = [];
  selectedDepartments: string[] = [];
 


 getDepartmentByPlantsLocation() {
  //  If no plant selected → RESET
  if (!this.selectedPlants || this.selectedPlants.length === 0) {
    this.departmentsList = [];
    this.selectedDepartments = [];
    return;
  }

  const payload = {
    companyId: this.loggedInUserCompanyID,
    plantLocations: this.selectedPlants.map((p: any) => p.id || p)
  };

  this.httpService.callPostService(this.config.getDwmDepartmentByPlantLocation, payload)
    .subscribe((res: any) => {
      this.departmentsList = (res?.data || []).map((item: string) => ({
        id: item,
        name: item
      }));
//       const excludedDepartments = ['R&D'];

// this.departmentsList = (res?.data || [])
//   .filter((item: string) => !excludedDepartments.includes(item))
//   .map((item: string) => ({
//     id: item,
//     name: item
//   }));

      //  Reset previously selected departments when plant changes
      this.selectedDepartments = [];
      this.employeesList = [];
      this.selectedEmployees = [];
    });
}



  onDepartmentSelect() {
  this.getEmployeesByPlantsLocationAndDepartments();
  }


  onDepartmentDeselect() {
  this.getEmployeesByPlantsLocationAndDepartments();
  }

  onDepartmentSelectAll(items:any[]) {
    this.selectedDepartments = items;
  this.getEmployeesByPlantsLocationAndDepartments();
  }

  onDepartmentDeSelectAll() {
    this.selectedDepartments = [];
  this.getEmployeesByPlantsLocationAndDepartments();
  }


downloadReport(downloadType: 'excel' | 'pdf') {
  const source = this.reportData || [];

  if (!source?.length) {
    this.toastr.warning('No task data to export!');
    return;
  }

  /* ===================== EXCEL ===================== */
  if (downloadType === 'excel') {
    const data = source.map(item => {
      return {
        'Employee ID': item.employeeId || '',
        'Employee Name': item.employeeName || '',
        'Plant Location': item.plantLocation || '',
        Department: item.department || '',
        Grade: item.grade || '',
        'Reporting Manager': item.reportingManager || '',
        'Submitted Tasks': item.tasksSubmittedForApproval || 0,
        'Approved Tasks': item.tasksApprovedByManager || 0,
        'Rejected Tasks': item.tasksRejectedByManager || 0,
        'Pending Approval': item.tasksPendingFromManagerApproval || 0,
        'Draft Tasks': item.draftTasks || 0,
        'Done On Time': item.tasksDoneOnTime || 0,
        'Done With Delay': item.tasksDoneWithDelay || 0,
        'Incomplete After Due Date': item.tasksIncompleteAfterDueDate || 0,
        'Not Completed': item.tasksNotCompleted || 0,
        'Compliance Score (%)': item.complianceScore ?? 0
      };
    });

    this.dwmGenericServiceService.saveAsExcelFile(
      data,
      'DWM Report',
      'dwm_report'
    );
  }

  /* ====================== PDF ====================== */
  if (downloadType === 'pdf') {

    // Dynamic headers from your table
    const pdfTableHeaders: string[] = this.teamTableHeaders.map(
      (header: any) => header.label
    );

    const data = source.map(item => {
      return [
        item.employeeId || '',
        item.employeeName || '',
        item.plantLocation || '',
        item.department || '',
        item.grade || '',
        item.reportingManager || '',
        item.tasksSubmittedForApproval || 0,
        item.tasksApprovedByManager || 0,
        item.tasksRejectedByManager || 0,
        item.tasksPendingFromManagerApproval || 0,
        item.draftTasks || 0,
        item.tasksDoneOnTime || 0,
        item.tasksDoneWithDelay || 0,
        item.tasksIncompleteAfterDueDate || 0,
        item.tasksNotCompleted || 0,
        item.complianceScore ?? 0
      ];
    });

    this.dwmGenericServiceService.downloadTableAsPdf(
      pdfTableHeaders,
      data,
      'DWM Dump Report',
      'dwm_dump_report',
      
    );
  }
}

  
  //  ------------------------------------------- Get Employees by Plant Location & Departments -------------------------------------
  employeeDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
     idField: 'id',      
    textField: 'name'
  };

  employeesList: any[] = [];
  selectedEmployees: string[] = [];
 


//  getEmployeesByPlantsLocationAndDepartments() {
//   //  If no plant selected → RESET
//   if (!this.selectedPlants || this.selectedPlants.length === 0) {
//     this.departmentsList = [];
//     this.selectedDepartments = [];
//     return;
//   }

//   const payload = {
//     companyId: this.loggedInUserCompanyID,
//     plantLocations: this.selectedPlants.map((p: any) => p.id || p),
//     department: this.selectedDepartments.map((d: any) => d.id || d)
//   };

//   this.httpService.callPostService(this.config.getDwmEmployeeByPlantLocationAndDepartment, payload)
//     .subscribe((res: any) => {
//       this.departmentsList = (res?.data || []).map((item: string) => ({
//         id: item,
//         name: item
//       }));

//       //  Reset previously selected departments when plant changes
//       this.selectedDepartments = [];
//     });
// }

getEmployeesByPlantsLocationAndDepartments() {

  //  If plant OR department not selected → RESET employees
  if (
    !this.selectedPlants || this.selectedPlants.length === 0 ||
    !this.selectedDepartments || this.selectedDepartments.length === 0
  ) {
    this.employeesList = [];
    this.selectedEmployees = [];
    return;
  }

  const payload = {
    companyId: this.loggedInUserCompanyID,
    plantLocations: this.selectedPlants.map((p: any) => p.id || p),
    department: this.selectedDepartments.map((d: any) => d.id || d)
  };

  this.httpService
    .callPostService(this.config.getDwmEmployeeByPlantLocationAndDepartment, payload)
    .subscribe((res: any) => {

      //  FIX: assign to employeesList (NOT departmentsList)
    this.employeesList = (res?.data || []).map((item: any) => ({
  id: item.id,
  name: `${item.firstName} ${item.lastName}`  
}));

      // Reset employee selection when filters change
      this.selectedEmployees = [];
    });
}


  onEmployeeSelect() {
   this.getDwmDumpReportData();
  }


  onEmployeeDeselect() {
 this.getDwmDumpReportData();
  }

  onEmployeeSelectAll(items:any[]) {
    this.selectedEmployees = items;
 this.getDwmDumpReportData();
  }

  onEmployeeDeSelectAll() {
    this.selectedEmployees = [];
 this.getDwmDumpReportData();
  }


  //  ------------------------------------------- Get DWM Dump Report Data -------------------------------------
  getMonthNumber(monthName: string): number {
  return this.monthsList.indexOf(monthName) + 1;
}

  // --------------------------- get report data for Non R&D Users --------------------------------------

  getDwmYear(): number {
    if (!this.selectedMonthForDWM || !this.filteredMonthsList?.length) {
      return Number(this.selectedYearForDWM?.split('-')[0]);
    }
    const [startYear, endYear] = this.selectedYearForDWM?.split('-').map(Number);
    const fiscalStartMonth = this.filteredMonthsList[0];
    return this.monthsList.indexOf(this.selectedMonthForDWM) < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;
  }

reportData: any[] = [];
originalReportData: any[] = []; 

  getDwmDumpReportData() {
      if (!this.selectedEmployees || this.selectedEmployees.length === 0) {
    this.reportData = [];
    return;
  }
    const payload = {
      companyId: this.loggedInUserCompanyID,
      // year: this.selectedYearForDWM,
       year: this.getDwmYear(),
      month: this.getMonthNumber(this.selectedMonthForDWM),
      userIds: this.selectedEmployees.map((e: any) => e.id || e)
    };

    this.httpService.callPostService(this.config.getDwmDumpReportData, payload)
      .subscribe((res: any) => {
            this.originalReportData = res?.data || [];
      this.reportData = [...this.originalReportData];
    this.currentPage = 1; 
    this.updatePagination();
     

      });
     }
  

  /* ------------------------- Filers ------------------------- */
onSearch(event: Event | null) {
  const value = (event?.target as HTMLInputElement)?.value?.toLowerCase() || '';

  if (!value) {
    this.reportData = [...this.originalReportData];
  } else {
    this.reportData = this.originalReportData.filter((item: any) =>
      Object.values(item).some(val =>
        String(val ?? '').toLowerCase().includes(value)
      )
    );
  }

  this.currentPage = 1; // reset page
  this.updatePagination();
}

  /* ------------------------- End Filers ------------------------- */

// ----------------------------- On Sort -----------------------------
tableState = {
  sortColumn: '',
  sortDirection: ''  as 'asc' | 'desc' | ''
};


onSort(column: string) {

  // Toggle sort direction
  if (this.tableState.sortColumn === column) {
    this.tableState.sortDirection =
      this.tableState.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.tableState.sortColumn = column;
    this.tableState.sortDirection = 'asc';
  }

  const direction = this.tableState.sortDirection === 'asc' ? 1 : -1;

  this.reportData.sort((a: any, b: any) => {

    let valA = a[column] ?? '';
    let valB = b[column] ?? '';

    //  Handle numbers
    if (!isNaN(valA) && !isNaN(valB)) {
      return (Number(valA) - Number(valB)) * direction;
    }

    //  Handle strings
    return valA.toString().toLowerCase()
      .localeCompare(valB.toString().toLowerCase()) * direction;
  });

  //  Update pagination after sorting
  this.updatePagination();
}

  // ---------------------------------------------------- Pagination --------------------------------------
  updatePagination() {
  this.totalEntries = this.reportData.length;
  this.totalPages = Math.ceil(this.totalEntries / this.pageSize);

  const startIndex = (this.currentPage - 1) * this.pageSize;
  const endIndex = startIndex + this.pageSize;

  this.paginatedData = this.reportData.slice(startIndex, endIndex);

  this.startEntry = this.totalEntries === 0 ? 0 : startIndex + 1;
  this.endEntry = Math.min(endIndex, this.totalEntries);
}

changePage(page: number) {
  if (page < 1 || page > this.totalPages) return;

  this.currentPage = page;
  this.updatePagination();
}

changePageSize(size: number) {
  this.pageSize = size;
  this.currentPage = 1;
  this.updatePagination();
}
}